import { cn } from '@/lib/utils'

interface ComboboxOptionState {
  /** Keyboard-highlighted (arrow keys / mouse-enter). */
  active?: boolean
  selected?: boolean
  disabled?: boolean
}

/**
 * Row class for hand-rolled searchable pickers (popover + filter input + option buttons), so they
 * match `SelectItem`: highlighted = foreground/10, selected = foreground/5, trailing Check icon.
 */
export function comboboxOptionClass({ active, selected, disabled }: ComboboxOptionState) {
  return cn(
    'flex w-full items-center justify-between gap-2 px-2 py-1.5 text-left text-sm',
    disabled
      ? 'cursor-not-allowed opacity-30'
      : active
        ? 'bg-foreground/10'
        : selected
          ? 'bg-foreground/5'
          : 'hover:bg-foreground/5'
  )
}
